import httpClient from '@/api/httpClient';

const getArchiveTreatment = ({ treatmentId }) =>
  httpClient.get(`/api/patients/treatments/archive/${treatmentId}`);

export { getArchiveTreatment };
